import { create } from 'zustand';

// Default visible columns for inspections table
const DEFAULT_VISIBLE_COLUMNS = [
  'inspectionType',
  'inspectedAt',
  'result',
  'truckId',
  'trailerId',
  'driverId',
  'defectCount',
];

interface InspectionsState {
  // Table columns and filters
  visibleColumns: string[];
  columnFilters: Record<string, string>;
}

interface InspectionsActions {
  // Column actions
  setVisibleColumns: (columns: string[]) => void;
  toggleColumn: (column: string) => void;

  // Filter actions
  setColumnFilter: (column: string, value: string) => void;
  setColumnFilters: (filters: Record<string, string>) => void;
  clearColumnFilters: () => void;

  // Utility
  resetAll: () => void;
}

type InspectionsStore = InspectionsState & InspectionsActions;

const initialState: InspectionsState = {
  visibleColumns: DEFAULT_VISIBLE_COLUMNS,
  columnFilters: {},
};

export const useInspectionsStore = create<InspectionsStore>()((set) => ({
  ...initialState,

  // Column actions
  setVisibleColumns: (visibleColumns) => set({ visibleColumns }),
  toggleColumn: (column) =>
    set((state) => ({
      visibleColumns: state.visibleColumns.includes(column)
        ? state.visibleColumns.filter((c) => c !== column)
        : [...state.visibleColumns, column],
    })),

  // Filter actions
  setColumnFilter: (column, value) =>
    set((state) => ({
      columnFilters: { ...state.columnFilters, [column]: value },
    })),
  setColumnFilters: (columnFilters) => set({ columnFilters }),
  clearColumnFilters: () => set({ columnFilters: {} }),

  // Utility
  resetAll: () => set(initialState),
}));
